var React = require('react');

function FlagPansexual (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_667_19106)","key":0},[React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","fill":"white","key":0}),React.createElement("rect",{"y":"0.333496","width":"32","height":"7.10933","fill":"#D82F6C","key":1}),React.createElement("rect",{"y":"7.44287","width":"32","height":"7.10933","fill":"#FCDF5C","key":2}),React.createElement("rect",{"y":"14.5522","width":"32","height":"7.10933","fill":"#4EC9F5","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_667_19106"},React.createElement("rect",{"y":"0.333496","width":"32","height":"21.3333","rx":"2.13333","fill":"white"})))]);
}

FlagPansexual.defaultProps = {"width":"32","height":"22","viewBox":"0 0 32 22","fill":"none"};

module.exports = FlagPansexual;

FlagPansexual.default = FlagPansexual;
